import router from '@/router';

const getDefaultState = () => {
    return {
        awcValue: null,
        cookiePreferences: JSON.parse(localStorage.getItem('cookie-preferences')),
        hasAnsweredCookieForm: JSON.parse(localStorage.getItem('cookie-preferences')),
        scriptsMounted: {
            necessary: false,
            analytics: false,
            tracking: false,
            stripe: false,
            zendesk: false,
            impact: false,
            awin: false,
            ga: false,
            gtm: false,
            optinMonster: false,
        },
    };
};

function gtag() {
    dataLayer.push(arguments);
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetScripts(state) {
            Object.assign(state, getDefaultState().scriptsMounted);
        },
        setAwcValue(state, payload) {
            state.awcValue = payload;
        },
        setCookiePreferences(state, payload) {
            state.cookiePreferences = payload;
            // state.hasAnsweredCookieForm = true;
            localStorage.setItem('cookie-preferences', JSON.stringify(payload));
        },
        showCookieBanner(state) {
            state.hasAnsweredCookieForm = false;
        },
        hideCookieBanner(state) {
            state.hasAnsweredCookieForm = true;
        },
        setScriptMounted(state, script) {
            state.scriptsMounted[script] = true;
        },
    },
    actions: {
        async mountScripts({ state, dispatch }) {
            dispatch('mountTrustPilot');
            dispatch('mountImpact');
            dispatch('mountZenDesk');

            // if (state.hasAnsweredCookieForm && state.cookiePreferences.analytics) {
            if (state.cookiePreferences.analytics) {
                dispatch('mountGoogleAnalytics');
                dispatch('mountOptinMonster');
            }
            // if (state.hasAnsweredCookieForm && state.cookiePreferences.tracking) {
            if (state.cookiePreferences.tracking) {
                dispatch('mountGoogleTagManager');
                dispatch('mountAWIN');
            }
        },

        async mountZenDesk({ state, commit }) {
            // returns as a promise in order to call the zE functions after script has loaded
            return new Promise((resolve, reject) => {
                if (!state.scriptsMounted.zendesk) {
                    let zendesk = document.createElement('script');
                    zendesk.src = 'https://static.zdassets.com/ekr/snippet.js?key=38e0af3b-899e-470e-9b97-b5daaf7b2655';
                    zendesk.type = 'text/javascript';
                    zendesk.id = 'ze-snippet';
                    zendesk.async = 1;
                    zendesk.onload = resolve;
                    zendesk.onerror = reject;
                    document.getElementsByTagName('body')[0].appendChild(zendesk);
                    commit('setScriptMounted', 'zendesk');
                } else {
                    resolve();
                }
            });
        },

        async mountStripe({ state, commit }) {
            if (!state.scriptsMounted.stripe) {
                let stripe = document.createElement('script');
                stripe.src = 'https://js.stripe.com/v3/';
                stripe.type = 'text/javascript';
                stripe.async = 1;
                document.getElementsByTagName('body')[0].appendChild(stripe);

                setTimeout(() => {
                    commit('setScriptMounted', 'stripe');
                }, 1000);
            }
        },

        async mountTrustPilot({ state, commit }) {
            if (!state.scriptsMounted.trustpilot) {
                let trustpilot = document.createElement('script');
                trustpilot.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
                trustpilot.type = 'text/javascript';
                trustpilot.async = 1;
                document.getElementsByTagName('body')[0].appendChild(trustpilot);
                commit('setScriptMounted', 'trustpilot');
            }
        },

        async mountGoogleAnalytics({ state, commit }) {
            if (process.env.VUE_APP_ENABLE_TRACKING === 'true' && !state.scriptsMounted.ga) {
                let googleTag = document.createElement('script');
                const GOOGLE_TAG_ID = process.env.GA_TRACKING_ID;
                googleTag.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
                googleTag.type = 'text/javascript';
                document.getElementsByTagName('body')[0].appendChild(googleTag);
                commit('setScriptMounted', 'ga');

                window.GA_TRACKING_ID = GOOGLE_TAG_ID;
                window.dataLayer = window.dataLayer || [];

                gtag('js', new Date());
                gtag('config', GA_TRACKING_ID, { app_name: 'Freddies Flowers Web App', send_page_view: false });

                router.afterEach((to) => {
                    gtag('config', window.GA_TRACKING_ID, {
                        page_path: to.fullPath,
                        app_name: 'Freddies Flowers Web App',
                        send_page_view: true,
                    });
                });

                router.afterEach((to) => {
                    dataLayer.push({
                        path: to.fullPath,
                    });
                });
            }
        },

        async mountGoogleTagManager({ state, commit }) {
            if (process.env.VUE_APP_ENABLE_TRACKING === 'true' && !state.scriptsMounted.gtm) {
                (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js',
                    });
                    var f = d.getElementsByTagName(s)[0];
                    var j = d.createElement(s);
                    var dl = l !== 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', 'GTM-K3CXLK3');
                commit('setScriptMounted', 'gtm');
            }
        },

        async mountRokt() {
            (function(r, o, k, t, n, e, w, a, _) {
                r._ROKT_ = n;
                r[n] = r[n] || {
                    id: t,
                    h: w,
                    lc: [],
                    it: new Date(),
                    onLoaded: (c) => {
                        r[n].lc.push(c);
                    },
                };
                a = o.createElement('script');
                a.type = 'text/javascript';
                a.async = !0;
                a.src = k;
                if (e) {
                    a.integrity = e;
                    a.crossOrigin = 'anonymous';
                }
                _ = o.getElementsByTagName('script')[0];
                _.parentNode.insertBefore(a, _);
            })(window, document, 'https://apps.rokt.com/wsdk/integrations/snippet.js', process.env.VUE_APP_ROKT_API_KEY, 'rokt');

            rokt.onLoaded((rokt) => {
                rokt.init({
                    skipInitialSelection: true,
                });
            });
        },

        async mountImpact({ state, commit }) {
            if (!state.scriptsMounted.impact) {
                (
                    function(a, b, c, d, e, f, g) {
                        e['ire_o'] = c;
                        e[c] = e[c] || function() {
                            (e[c].a = e[c].a || []).push(arguments);
                        };
                        f = d.createElement(b);
                        g = d.getElementsByTagName(b)[0];
                        f.async = 1;
                        f.src = a;
                        g.parentNode.insertBefore(f, g);
                    }
                )('https://d.impactradius-event.com/A2455256-5c81-42ea-9407-2d35fa6fe9e51.js', 'script', 'ire', document, window);
                ire('identify', { customerid: '', customeremail: '' });
                commit('setScriptMounted', 'impact');
            }
        },

        async mountAWIN({ state, commit }) {
            if (!state.scriptsMounted.awin) {
                var awMastertag = document.createElement('script');
                awMastertag.setAttribute('defer', 'defer');
                awMastertag.src = `https://www.dwin1.com/${process.env.VUE_APP_AWIN_KEY}.js`;
                awMastertag.type = 'text/javascript';
                document.getElementsByTagName('body')[0].appendChild(awMastertag);
                commit('setScriptMounted', 'awin');
            }
        },

        async mountOptinMonster({ state, commit }) {
            if (!state.scriptsMounted.optinMonster) {
                (function(d, u, ac) {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.src = 'https://a.omappapi.com/app/js/api.min.js';
                    s.async = true;
                    s.dataset.user = u;
                    s.dataset.account = ac;
                    d.getElementsByTagName('head')[0].appendChild(s);
                })(document, 182930, 197778);
                commit('setScriptMounted', 'optinMonster');
            }
        },
    },
    getters: {
        getAllowsAnalytics: (state) => state.cookiePreferences && state.cookiePreferences.analytics,

        getAwcValue: (state) => state.awcValue,

        getCookiePreferences: (state) => state.cookiePreferences,

        getHasAnsweredCookieForm: (state) => state.hasAnsweredCookieForm,

        isStripeMounted: (state) => state.scriptsMounted.stripe,

        isZendeskMounted: state => state.scriptsMounted.zendesk,
    },
};
